import { Injectable } from '@angular/core';
import { HttpApiService } from '@app/providers/http-api/http-api.service';

import { Observable, map } from 'rxjs';

@Injectable()
export class LoansService {
  loansData: any;

  constructor(private httpApi: HttpApiService) {}

  /* loans methods */
  getLoans(userId: any): any {
    return this.httpApi
      .get(`/user/${userId}/loan/global`)
      .pipe(map((res: { data: any }) => this.processLoansData(res.data)));
  }

  getLoanCapacity(userId: any, nbMonth: any, rate: any, rentRate: any): any {
    return this.httpApi.get(
      `/user/${userId}/loan/capacity?nbMonth=${nbMonth}&rate=${rate}&rentRate=${rentRate}`,
    );
  }

  getLoansList(userId: any): any {
    return this.httpApi.get(`/user/${userId}/loan`);
  }

  getLoansListNotAssociate(userId: any): any {
    return this.httpApi.get(`/user/${userId}/loan/noAssociate`);
  }

  getLoan(userId: any, loanId: any): any {
    return this.httpApi.get(`/user/${userId}/loan/${loanId}`);
  }

  updateLoan(userId: any, body: any): any {
    return this.httpApi.post(`/user/${userId}/loan`, body);
  }

  deleteLoan(userId: any, loanId: any): any {
    return this.httpApi.delete(`/user/${userId}/loan/${loanId}`);
  }

  computeLoanMonthlyAmount(
    amount: number,
    duration: number,
    rate: number,
    insuranceRate: number,
  ): Observable<any> {
    return this.httpApi.get(`/services/loan/fix-rate/monthly-amount`, {
      amount: amount.toString(),
      duration: duration.toString(),
      rate: rate.toString(),
      insuranceRate: insuranceRate.toString(),
    });
  }

  processLoansData(data: any): any {
    if (data) {
      let obj = {};
      obj['ratio'] = typeof data.debitRatio !== 'number' ? 0 : data.debitRatio;
      obj['total'] = data.total;
      obj['totalMonth'] =
        typeof data.totalMonth !== 'number' ? 0 : data.totalMonth;
      obj['personalUse'] = data.personalUse;
      obj['outstanding'] = data.outstanding;
      obj['rental'] = data.rental;
      obj['totalEarning'] = data.totalEarning;
      obj['amountLeftOver'] = data.amountLeftOver;

      if (data.repartition && data.repartition.series) {
        obj['pieData'] = data.repartition.series;
      }
      // format loans list items
      if (data.list) {
        let loansList = [];
        data.list.forEach(function (item) {
          let loan = {};
          loan['id'] = item.id;
          loan['typeProject'] = item.typeProject;
          loan['typeProjectTrad'] = item.typeProjectTrad;
          loan['typeRate'] = item.typeRate;
          loan['insuranceRate'] = item.insuranceRate || 0;
          loan['amount'] = Number(item.amount);
          loan['label'] = item.label;
          loan['associatedInvestmentLabel'] = item.associatedInvestmentLabel;
          loan['duration'] = item.duration || 0;
          loan['monthAmount'] = Number(item.monthAmount);
          loan['rate'] = item.rate ? Number(item.rate) : 0;
          loan['startDate'] = item.startDate;
          loan['signatureDate'] = item.signatureDate;
          loan['endDate'] = item.endDate;
          loan['depreRateName'] = item.typeDepreciationRate;
          if (item.evolution) {
            loan['evolution'] = item.evolution;
          }
          loansList.push(loan);
        });

        obj['list'] = loansList;
      }

      // outstanding data
      if (data.evolution) {
        obj['evolution'] = data.evolution;
      }
      this.loansData = obj;
    }
    return this.loansData;
  }
}
